import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="logo">
        <img src="/img/logo.png" alt="logo" />
        Kaab Dental Experts
      </div>

      {/* Botón hamburguesa / cerrar */}
      <button
        className="menu-toggle"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label="Toggle menu"
      >
        {isOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Menú de navegación */}
      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li>
          <a href="#servicios" onClick={() => setIsOpen(false)}>
            Servicios
          </a>
        </li>
        { /* Temporally removed, missing employee info
          <li>
            <a href="#equipo" onClick={() => setIsOpen(false)}>
              Equipo
            </a>
          </li>
          */
        }
        <li>
          <a href="#home" onClick={() => setIsOpen(false)}>
            Citas
          </a>
        </li>
        <li>
          <a href="#contacto" onClick={() => setIsOpen(false)}>
            Contacto
          </a>
        </li>
      </ul>
    </nav>
  );
}
